// extracted by mini-css-extract-plugin
export default {"register_page":"RegisterPage_register_page__rbLEE"};